import { BodyLocationType } from '@/api/api.schemas';
import { useTranslation } from '@/contexts/i18n-context';
import { Select, SelectProps } from '../inputs/select';

export function BodyLocationSelector({
  placeholder,
  className,
  ...restProps
}: Omit<SelectProps, 'options'>) {
  const { t } = useTranslation();

  return (
    <Select
      {...restProps}
      className={className}
      placeholder={placeholder}
      options={Object.values(BodyLocationType).map((title) => ({
        value: title,
        label: t(`bodyLocation.${title}`),
      }))}
    />
  );
}
